
































































































































































































import {
  Component,
  Vue,
  Inject,
  Prop,
  Emit,
  Watch,
} from 'vue-property-decorator'
import moment from 'moment'
import Api from '@/api/wechat/mpUserInfo/index'

import DateTimeRange from '@/components/datetime-range/newDatetime.vue'

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'

import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
@Component({
  components: {
    'v-chart': ECharts,
    DateTimeRange,
  },
})
export default class MpUserReport extends Vue {
  spinShow: boolean = false
  startTime: string = ''
  endTime: string = ''
  isShowMoM: boolean = true
  YoYVlaue: string = '较前1日'
  /**
   * 运营概况数据
   */
  operationOverviewData = {
    payAmount: 0,
    payUnivalent: 0,
    payBuyers: 0,
    payOrders: 0,
    payCount: 0,
    payPrice: 0,
    customerPriceMomPercent: 0,
    customerPriceYoyPercent: 0,
    orderItemCountMomPercent: 0,
    orderItemCountYoyPercent: 0,
    payAmountMomPercent: 0,
    payAmountYoyPercent: 0,
    payBuyerMomPercent: 0,
    payBuyerYoyPercent: 0,
    payQuantityMomPercent: 0,
    payQuantityYoyPercent: 0,
    refundAmountMomPercent: 0,
    refundAmountYoyPercent: 0
  }
  /**
   * 产品销售数据开始
   */
  columns1 = [
    {
      title: '排名',
      key: 'rank',
      align: 'center',
      width: 120,
    },
    {
      title: '产品名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '访客（uv）',
      key: 'visitors',
      align: 'center',
    },
    {
      title: '销售数量',
      key: 'payQuantity',
      align: 'center',
    },
    {
      title: '销售金额',
      key: 'payAmount',
      align: 'center',
    },
    {
      title: '支付人数',
      key: 'payBuyer',
      align: 'center',
    },
    {
      title: '转化率',
      key: 'payConversionRate',
      align: 'center',
    },
  ]
  data1 = []
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  pcData = {
    proportion: 0,
    price: 0,
    goodsCount: 0,
    buyers: 0,
  }
  appletsData = {
    proportion: 0,
    price: 0,
    goodsCount: 0,
    buyers: 0,
  }
  /**
   * 产品销售数据结束
   */
  /**
   * 浏览来源排行数据开始
   */
  columns2 = [
    {
      title: '排名',
      key: 'rank',
      align: 'center',
    },
    {
      title: '来源名称',
      key: 'channel',
      align: 'center',
    },
    {
      title: '访客（uv）',
      key: 'visitors',
      align: 'center',
    },
    {
      title: '支付买家数',
      key: 'payBuyer',
      align: 'center',
    },
    {
      title: '支付金额',
      key: 'payAmount',
      align: 'center',
    },
  ]
  data2 = []
  pagerBrowse = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  /**
   * 浏览来源排行数据结算
   */
  pieDataPc = {
    title: {
      text: '交易构成',
      x: 'center',
      textStyle: {
        fontWeight: 'normal', //标题颜色
        color: '#437cff',
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)',
    },
    legend: {
      orient: 'center',
      bottom: 0,
      right: '35%',
      data: ['PC商城', '小程序'],
    },
    series: [
      {
        name: '关注来源',
        type: 'pie',
        radius: '65%',
        center: ['50%', '50%'],
        data: [
          {
            value: 0.5,
            name: 'PC商城',
            itemStyle: { normal: { color: '#3267e2' } },
          },
          {
            value: 1 - 0.5,
            name: '小程序',
            itemStyle: { normal: { color: '#91c4ff' } },
          },
        ],
        // itemStyle: {
        //   normal: {
        //     label: {
        //       show: false,
        //     },
        //     labelLine: {
        //       show: false,
        //     },
        //   },
        // },
      },
    ],
  }
  pieDataApplets = {
    title: {
      text: '小程序商城',
      x: 'center',
      textStyle: {
        fontWeight: 'normal', //标题颜色
        color: '#437cff',
      },
    },
    // tooltip: {
    //   trigger: 'item',
    //   formatter: '{a} <br/>{b} : {c} ({d}%)',
    // },
    // legend: {
    // orient: 'center',
    // bottom: 0,
    // right: 0,
    // data: ['通过店铺扫码关注', '其他'],
    // },
    series: [
      {
        name: '关注来源',
        type: 'pie',
        radius: '65%',
        center: ['50%', '50%'],
        data: [
          {
            value: 1,
            name: '2222',
            itemStyle: { normal: { color: '#3267e2' } },
          },
          {
            value: 1,
            name: '3232',
            itemStyle: { normal: { color: '#91c4ff' } },
          },
        ],
        itemStyle: {
          normal: {
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
          },
        },
      },
    ],
  }
  mounted() {
    this.startTime = moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD 00:00:00')
    this.endTime = moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD 23:59:59')
    console.log('昨天时间', this.startTime, this.endTime)
    this.loadOperationalData(this.startTime, this.endTime)
    this.loadProductSalesData(this.startTime, this.endTime)
    this.loadTransactionAnalysisData(this.startTime, this.endTime)
    this.loadTrafficSourceData(this.startTime, this.endTime)
  }
  dateTimeChange(e, dateTime) {
    console.log(e, dateTime)
    if (dateTime === '最近7天' || dateTime === '最近30天') {
      if(dateTime === '最近7天') {
        this.YoYVlaue = '较前7天'
      }else {
        this.YoYVlaue = '较前30天'
      }
      this.isShowMoM = false
    } else if(dateTime === '昨天') {
      this.YoYVlaue = '较前1日'
      this.isShowMoM = true
    }else {
      this.YoYVlaue = '较上一个周期'
      this.isShowMoM = false
    }
    this.loadOperationalData(e[0], e[1])
    this.loadProductSalesData(e[0], e[1])
    this.loadTransactionAnalysisData(e[0], e[1])
    this.loadTrafficSourceData(e[0], e[1])
    this.startTime = e[0]
    this.endTime = e[1]
  }
  loadOperationalData(begin, end) {
    Api.getOperationalData(begin, end)
      .then((res) => {
        console.log('运营概况', res)
        this.operationOverviewData.payAmount = res.data.payAmount
        this.operationOverviewData.payUnivalent = res.data.customerPrice
        this.operationOverviewData.payBuyers = res.data.payBuyer
        this.operationOverviewData.payOrders = res.data.orderItemCount
        this.operationOverviewData.payCount = res.data.payQuantity
        this.operationOverviewData.payPrice = res.data.refundAmount
        this.operationOverviewData.customerPriceMomPercent = res.data.customerPriceMomPercent
        this.operationOverviewData.customerPriceYoyPercent = res.data.customerPriceYoyPercent
        this.operationOverviewData.orderItemCountMomPercent = res.data.orderItemCountMomPercent
        this.operationOverviewData.orderItemCountYoyPercent = res.data.orderItemCountYoyPercent
        this.operationOverviewData.payAmountMomPercent = res.data.payAmountMomPercent
        this.operationOverviewData.payAmountYoyPercent = res.data.payAmountYoyPercent
        this.operationOverviewData.payBuyerMomPercent = res.data.payBuyerMomPercent
        this.operationOverviewData.payBuyerYoyPercent = res.data.payBuyerYoyPercent
        this.operationOverviewData.payQuantityMomPercent = res.data.payQuantityMomPercent
        this.operationOverviewData.payQuantityYoyPercent = res.data.payQuantityYoyPercent
        this.operationOverviewData.refundAmountMomPercent = res.data.refundAmountMomPercent
        this.operationOverviewData.refundAmountYoyPercent = res.data.refundAmountYoyPercent
      })
      .catch((err) => {
        console.log(err)
      })
  }
  loadProductSalesData(begin, end) {
    Api.getProductSalesData(
      begin,
      end,
      this.pager.pageSize,
      this.pager.pageIndex
    )
      .then((res) => {
        console.log('产品销售排行', res)
        this.data1 = res.data.items
        this.pager.total = res.data.totalCount
      })
      .catch((err) => {
        console.log(err)
      })
  }
  loadTransactionAnalysisData(begin, end) {
    this.spinShow = true
    Api.getTransactionAnalysisData(begin, end)
      .then((res) => {
        console.log('交易分析数据', res)
        this.spinShow = false
        if (!res.data.items.length) {
          this.pieDataApplets.series[0].data[0].value = 1
          this.pieDataApplets.series[0].data[1].value = 1
          this.pieDataPc.series[0].data[0].value = 1
          this.pieDataPc.series[0].data[1].value = 1
          this.appletsData.proportion = 0
          this.appletsData.price = 0
          this.appletsData.goodsCount = 0
          this.appletsData.buyers = 0
          this.pcData.proportion = 0
          this.pcData.price = 0
          this.pcData.goodsCount = 0
          this.pcData.buyers = 0
        }
        res.data.items.forEach((item) => {
          if (item.terminal == 0) {
            this.pieDataPc.series[0].data[1].value = item.amountProportion
            this.appletsData.proportion = item.amountProportion
            this.appletsData.price = item.paymentAmount
            this.appletsData.goodsCount = item.payQuantity
            this.appletsData.buyers = item.payBuyer
          } else if (item.terminal == 1) {
            this.pieDataPc.series[0].data[0].value = item.amountProportion
            this.pcData.proportion = item.amountProportion
            this.pcData.price = item.paymentAmount
            this.pcData.goodsCount = item.payQuantity
            this.pcData.buyers = item.payBuyer
          }
          // switch (item.terminal) {
          //   case 0:
          //     this.pieDataApplets.series[0].data[0].value = item.amountProportion?item.amountProportion:1
          //     this.pieDataApplets.series[0].data[1].value = 1 - (item.amountProportion?item.amountProportion:0)
          //     this.appletsData.proportion = item.amountProportion
          //     this.appletsData.price = item.paymentAmount
          //     this.appletsData.goodsCount = item.payQuantity
          //     this.appletsData.buyers = item.payBuyer
          //     break
          //   case 1:
          //     this.pieDataPc.series[0].data[0].value = item.amountProportion?item.amountProportion:1
          //     this.pieDataPc.series[0].data[1].value = 1 - (item.amountProportion?item.amountProportion: 0)
          //     this.pcData.proportion = item.amountProportion
          //     this.pcData.price = item.paymentAmount
          //     this.pcData.goodsCount = item.payQuantity
          //     this.pcData.buyers = item.payBuyer
          //     break
          //   default:
          //     break
          // }
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
  loadTrafficSourceData(begin, end) {
    Api.getTrafficSourceData(begin, end)
      .then((res) => {
        console.log('浏览来源', res)
        this.data2 = res.data.items
      })
      .catch((err) => {
        console.log(err)
      })
  }
  /**
   * 产品销售排行页数事件
   */
  onPageChange(pageIndex: number) {
    this.pager.pageIndex = pageIndex
    this.loadProductSalesData(this.startTime, this.endTime)
  }

  /**
   * 浏览来源排行
   */
  // onPageChangeBrowse() {}
}
